import domain from './domain';

// Reset open task list data
export const resetCoreUserOpenTaskListData = domain.createEvent('resetCoreUserOpenTaskListData');
